// Global method for getting a label from the statemanager.
// It relies on a Vuex Action and is, mostly, a wrapped action for easier use in components.
// A label must be available for readout, or the method returns the labelKey itself - indicating there is a missing label.

import { useLabelsStore } from 'stores/labels.store'

/**
 * 
 * @param {Object} payload 
 * @param {String} payload.labelKey - key of the label
 * @param {String} payload.collectionName - name of the label collection
 * @param {Array} payload.params - array of params 
 * @returns 
 */
export default function(payload){
    const store = useLabelsStore()
    const returnedLabel = store.getLabel(payload)
    if (returnedLabel !== undefined && payload.allowEmpty)
        return returnedLabel
    
    return returnedLabel || payload.labelKey
}